import { useCallback } from 'react'

import {
  OpportunityAppDataInput,
  SoldServiceAppDataModel,
} from '@user/store/opportunity'

import { parseFieldValue } from '../functions'
import { SoldServicesFormModel } from '../typings'
import { AdditionalInfoEditProps } from '../AdditionalInfoEdit'
import {
  useCWQDialogContext,
  closeDialogActionCreator as closeDialog,
} from '@user/components/SoldServices'

type Props = Pick<
  AdditionalInfoEditProps,
  'entityId' | 'onCloseWin' | 'closedWonStageId'
> & {
  appData: SoldServiceAppDataModel[]
}

export function useHandlers(props: Props) {
  const { entityId, closedWonStageId, onCloseWin, appData } = props

  const [, dispatch] = useCWQDialogContext()

  const onCancel = useCallback(() => dispatch(closeDialog()), [dispatch])

  const onSubmit = useCallback(
    async (formModel: SoldServicesFormModel) => {
      const { customFields } = formModel

      const fieldNames = Object.keys(customFields)

      const input = fieldNames.reduce<OpportunityAppDataInput[]>(
        (acc, fieldName) => {
          const model = appData.find((x) => x.id === fieldName)
          if (!model) return acc

          const { id, caption, type } = model

          const rawValue = customFields[fieldName]

          const { value, valueId } = parseFieldValue(model, rawValue)

          const input: OpportunityAppDataInput = {
            value,
            valueId,
            key: id,
            caption,
            valueType: type,
          }

          return [...acc, input]
        },
        [],
      )

      await onCloseWin({
        opportunityId: entityId,
        appData: input,
        salesNote: formModel.salesNote,
        closedWonFunnelStageId: closedWonStageId,
      })
    },
    [appData, closedWonStageId, onCloseWin, entityId],
  )

  return {
    onSubmit,
    onCancel,
  }
}
